import React from 'react'
import PrimaryTooltip from 'app/componentV4/Tooltip/PrimaryTooltip'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import NotificationsNoneOutlinedIcon from '@material-ui/icons/NotificationsNoneOutlined'
import QueryBuilderOutlinedIcon from '@material-ui/icons/QueryBuilderOutlined'
import StarBorderOutlinedIcon from '@material-ui/icons/StarBorderOutlined'
import CardGiftcardOutlinedIcon from '@material-ui/icons/CardGiftcardOutlined'
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined'
import { GeneralRemiderTypeIcon } from 'app/components/icons'
import { FormattedMessage, useIntl } from 'react-intl'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import { isEmptyOrNil } from 'libs/empty'

export default (props) => {
  const { values, isBeacon } = props
  const { formatMessage } = useIntl()
  return (
    <div className="flex text-16 space-x-5 items-center px-4 text-blue-950">
      <div className="text-14 text-blue-950 font-medium capitalize">
        <FormattedMessage id="timeline.filter.more.option" />
      </div>
      <div className="hidden sm:flex space-x-5 items-center">
        <PrimaryTooltip
          title={formatMessage({
            id: 'createNotification.dialog.notiType',
          })}
        >
          <div className="relative bg-primary-200 p-2 rounded-4 flex items-center">
            {!isEmptyOrNil(values.notiType) && (
              <CheckCircleIcon
                style={{ fontSize: '12px', color: '#00B2AD' }}
                className="absolute top-0 right-0"
              />
            )}
            <InfoOutlinedIcon />
          </div>
        </PrimaryTooltip>

        <PrimaryTooltip
          title={formatMessage({
            id: 'createNotification.dialog.notiPriority',
          })}
        >
          <div className="relative bg-primary-200 p-2 rounded-4 flex items-center">
            {!isEmptyOrNil(values.priority) && (
              <CheckCircleIcon
                style={{ fontSize: '12px', color: '#00B2AD' }}
                className="absolute top-0 right-0"
              />
            )}
            <NotificationsNoneOutlinedIcon />
          </div>
        </PrimaryTooltip>
        {!isBeacon && (
          <PrimaryTooltip
            title={formatMessage({
              id: 'createNotification.dialog.expiration',
            })}
          >
            <div className="relative bg-primary-200 p-2 rounded-4 flex items-center">
              {values.expirationTime > 0 && (
                <CheckCircleIcon
                  style={{ fontSize: '12px', color: '#00B2AD' }}
                  className="absolute top-0 right-0"
                />
              )}
              <QueryBuilderOutlinedIcon />
            </div>
          </PrimaryTooltip>
        )}
        {!isBeacon && (
          <PrimaryTooltip
            title={formatMessage({
              id: 'notifications.topics.label',
            })}
          >
            <div className="relative bg-primary-200 p-2 rounded-4 flex items-center">
              {!isEmptyOrNil(values.topics) && (
                <CheckCircleIcon
                  style={{ fontSize: '12px', color: '#00B2AD' }}
                  className="absolute top-0 right-0"
                />
              )}
              <StarBorderOutlinedIcon />
            </div>
          </PrimaryTooltip>
        )}

        <PrimaryTooltip
          title={formatMessage({
            id: 'notification.type.voucher',
          })}
        >
          <div className="relative bg-primary-200 p-2 rounded-4 flex items-center">
            {!isEmptyOrNil(values.voucher) && (
              <CheckCircleIcon
                style={{ fontSize: '12px', color: '#00B2AD' }}
                className="absolute top-0 right-0"
              />
            )}
            <CardGiftcardOutlinedIcon />
          </div>
        </PrimaryTooltip>
        <PrimaryTooltip
          title={formatMessage({
            id: 'compose.dialog.schedule.message.label',
          })}
        >
          <div className="relative bg-primary-200 p-2 rounded-4 flex items-center">
            {!isEmptyOrNil(values.schedule) && (
              <CheckCircleIcon
                style={{ fontSize: '12px', color: '#00B2AD' }}
                className="absolute top-0 right-0"
              />
            )}
            <DateRangeOutlinedIcon />
          </div>
        </PrimaryTooltip>
        {!isBeacon && (
          <PrimaryTooltip
            title={formatMessage({
              id: 'text.reminder',
            })}
          >
            <div className="relative bg-primary-200 p-2 rounded-4 flex items-center">
              {!isEmptyOrNil(values.reminder) && (
                <CheckCircleIcon
                  style={{ fontSize: '12px', color: '#00B2AD' }}
                  className="absolute top-0 right-0"
                />
              )}
              <GeneralRemiderTypeIcon fill="#183560" />
            </div>
          </PrimaryTooltip>
        )}
      </div>
    </div>
  )
}
